import { render, staticRenderFns } from "./MahnungAddressOverview.vue?vue&type=template&id=2b6196fe"
import script from "./MahnungAddressOverview.vue?vue&type=script&lang=ts"
export * from "./MahnungAddressOverview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports